/**
 * @file 用户、权限相关接口
 * @author zhanghaohan
 */

import {stringify} from 'qs';
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import parseUrl from '../../../utils/parseUrl';
import API from './api';

// uc账号 token代登录用，链接里取 非必传，不传按正常pass用户登录
const {ucid = '', castk = ''} = parseUrl(window.location.search);
const ucParams = {
    ucid,
    castk
};

// 中控台相关接口host
// let HOST = 'https://liveshowserv.baidu.com';
// 直播间相关接口host
// let HOST2 = 'https://tiebac.baidu.com';

// if (process.env.NODE_ENV === 'development') {
//     HOST = '';
//     HOST2 = '';
// }

// sign加密标示
// const token = 'tiebaclient!!!';

// sign签名加密函数
// const dictionaryOrder = data => {
//     let str = '';
//     const allkeys = Object.keys(data).sort();
//     for (let i = 0, len = allkeys.length; i < len; i++) {
//         str += `${allkeys[i]}=${data[allkeys[i]]}`;
//     }
//     return str;
// };

/**
 * 查询用户登录信息
 * @returns Promise
 */
export const getUserInfo = () => {
    const params = ucParams;
    return request(
        `${API.GET_USER_INFO}?${stringify(params)}`, {
            method: 'GET'
        }
    );
};

/**
 * 数字人前置权限判断
 * @returns Promise
 */
export const checkPreAuth = async () => {
    return request(
        API.PRE_CHECK_LIST, {
            method: 'POSTJSON',
            body: {
                type: 1
            }
        }
    );
};

/**
 * 校验注册码
 * @returns Promise
 */
export const checkRegistCode = async params => {
    return request(
        API.CHECK_REGIST_CODE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 签署平台协议
 * @returns Promise
 */
export const confirmAgreement = async params => {
    return request(
        API.CONFIRM_AGREEMENT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 签署数字人制作协议
 * @param {object} params
 * @returns
 */
export const confirmAnchorMakerAgreement = async params => {
    return request(
        API.CONFIRM_ONE_CLICK_LIVE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 查询数字人制作协议签署结果
 * @param {object} params
 * @returns
 */
export const anchorMakerAgreementResult = async (params = {}) => {
    return request(
        API.ONE_CLICK_LIVE_RESULT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 校验数字人白名单权限
 * @returns Promise
 */
export const checkDigitalAnchorAuth = async () => {
    return request(
        API.WHITE_LIST, {
            method: 'POSTJSON',
            body: {
                type: 1
            }
        }
    );
};

/**
 * 获取初始化IM消息用castid
 * @returns Promise
 */
export const getIMCastId = async () => {
    return request(API.GET_CAST_ID, {
        method: 'POSTJSON'
    });
};

/**
 * 提交音频列表
 * @returns Promise
 */
export const saveMediaInfo = async params => {
    return request(API.SET_MEDIA_INFO, {
        method: 'POSTJSON',
        body: params
    });
};

/**
 * 提交保存手机留资信息
 * @returns Promise
 */
export const saveMobileManagerInfo = async params => {
    return request(API.SET_MOBILE_MANAGER_INFO, {
        method: 'POSTJSON',
        body: params
    });
};

/**
 * 获取音频下拉框信息
 * @returns Promise
 */
export const getMediaSelectInfo = async params => {
    return request(API.GET_TTS_TAG_LIST, {
        method: 'POSTJSON',
        body: params
    });
};

/**
 * 获取用户是否使用新手引导
 * @returns Promise
 */
export const getUserGuide = async params => {
    return request(API.GET_USER_GUIDE, {
        method: 'POSTJSON',
        body: params
    });
};

/**
 * 设置用户已经使用新手引导
 * @returns Promise
 */
export const setUserGuide = async params => {
    return request(API.SET_USER_GUIDE, {
        method: 'POSTJSON',
        body: params
    });
};
